import { EventEmitter } from 'events';

/**
 * calculate fps
 */
export default class FPS extends EventEmitter {
  private frameFps: number[];
  private frameDeltas: number[];
  private lastFrameTimeStamp: number;
  constructor() {
    super();
    this.frameFps = [];
    this.frameDeltas = [];
    this.lastFrameTimeStamp = performance.now();
  }

  render() {
    const now = performance.now();
    const delta = now - this.lastFrameTimeStamp;
    this.lastFrameTimeStamp = now;
    // Guard against zero/negative delta due to timer precision.
    const safeDelta = Math.max(delta, Number.EPSILON);
    const fps = 1000 / safeDelta;

    this.frameFps.push(fps);
    this.frameDeltas.push(safeDelta);
    if (this.frameFps.length > 100) {
      this.frameFps.shift();
      this.frameDeltas.shift();
    }
    this.emit('update');
  }

  public measure(): { latest: number; avg: number; min: number; max: number } {
    if (this.frameFps.length === 0) {
      return {
        latest: 0,
        avg: 0,
        min: 0,
        max: 0,
      };
    }

    let min = Infinity;
    let max = -Infinity;
    let totalDelta = 0;

    for (let i = 0; i < this.frameFps.length; i++) {
      const fps = this.frameFps[i];
      min = Math.min(fps, min);
      max = Math.max(fps, max);
      totalDelta += this.frameDeltas[i];
    }

    const avg = totalDelta > 0 ? (this.frameFps.length * 1000) / totalDelta : 0;
    return {
      latest: Math.round(this.frameFps[this.frameFps.length - 1]),
      avg: Math.round(avg),
      min: Math.round(min),
      max: Math.round(max),
    };
  }
}
